/* Skinny Genie redesign: Contact page behaviour.
   Loaded only by sections/page-contact.liquid. */
(function () {
  'use strict';

  /* ----------------------------------------------------------------
     Enquiry tabs.
     The mockup ships two identical forms and shows one at a time. Here
     there is a single Shopify contact form instead, so the tabs swap the
     intro copy, the comment placeholder and a hidden "Enquiry type"
     field that rides along in the email. Visually identical, and only
     one form can post, so only one success or error banner can appear.
     ---------------------------------------------------------------- */
  var TABS = {
    general: {
      btn: 'contact-tab-general',
      intro: 'contact-form-general-intro',
      placeholder: 'Tell us about your order, product question, or feedback…',
      label: 'General & retail'
    },
    wholesale: {
      btn: 'contact-tab-wholesale',
      intro: 'contact-form-wholesale-intro',
      placeholder: "Tell us about your business, the volumes you need, and what you're looking to source or manufacture…",
      label: 'Wholesale & contract manufacturing'
    }
  };

  function setContactTab(which) {
    if (!TABS[which]) return;
    Object.keys(TABS).forEach(function (key) {
      var t = TABS[key];
      var btn = document.getElementById(t.btn);
      var intro = document.getElementById(t.intro);
      if (btn) {
        btn.classList.toggle('active', key === which);
        btn.setAttribute('aria-selected', key === which ? 'true' : 'false');
      }
      if (intro) intro.hidden = key !== which;
    });
    var comment = document.getElementById('contact-form-comment');
    if (comment) comment.setAttribute('placeholder', TABS[which].placeholder);
    var type = document.getElementById('contact-enquiry-type');
    if (type) type.value = TABS[which].label;
  }

  /* ----------------------------------------------------------------
     Delivery checker.
     The delivery fees, minimums and excluded areas live in exactly one
     place: SG_DELIVERY_ZONES in skinny-genie-base.js, which also powers the
     header's location modal. Restating those figures here would give the
     site two copies of its own pricing, free to drift apart. So this card
     calls the same checkDelivery(), scoped to the card, and the modal
     stays closed the whole time.
     ---------------------------------------------------------------- */
  function checkDeliveryInline(zone) {
    var card = document.querySelector('.contact-delivery-card');
    if (!card) return;
    if (typeof window.checkDelivery !== 'function') {
      var out = card.querySelector('.location-result');
      out.className = 'location-result fail';
      out.textContent = 'The delivery checker is not available right now. Please contact us and we will confirm your area.';
      return;
    }
    window.checkDelivery(zone, card);
  }

  /* ----------------------------------------------------------------
     Sticky subnav scrollspy, matching the other rebuilt pages.
     ---------------------------------------------------------------- */
  function initScrollspy() {
    var nav = document.querySelector('.contact-subnav');
    if (!nav || !('IntersectionObserver' in window)) return;
    var links = Array.prototype.slice.call(nav.querySelectorAll('a[href^="#"]'));
    var map = {};
    var targets = [];
    links.forEach(function (a) {
      var id = a.getAttribute('href').slice(1);
      var el = document.getElementById(id);
      if (el) { map[id] = a; targets.push(el); }
    });
    if (!targets.length) return;

    var spy = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        links.forEach(function (a) { a.classList.remove('active'); });
        var a = map[entry.target.id];
        if (a) a.classList.add('active');
      });
    }, { rootMargin: '-45% 0px -50% 0px', threshold: 0 });

    targets.forEach(function (el) { spy.observe(el); });
  }

  function init() {
    var tabs = document.querySelector('.contact-tabs');
    if (tabs) {
      tabs.addEventListener('click', function (e) {
        var btn = e.target.closest('.contact-tab-btn');
        if (btn && btn.dataset.tab) setContactTab(btn.dataset.tab);
      });
    }

    var card = document.querySelector('.contact-delivery-card');
    if (card) {
      card.addEventListener('click', function (e) {
        var chip = e.target.closest('.location-chip[data-zone]');
        if (chip) checkDeliveryInline(chip.getAttribute('data-zone'));
      });
    }

    initScrollspy();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
